"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyLinkInputButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for copying a link to the clipboard.
 * @param {CopyLinkInputButtonProps} props - The props for the component.
 * @returns {JSX.Element}
 */
const CopyLinkInputButton = ({
  link,
  buttonText,
  copiedText,
  className,
  fullWidth,
  backgroundGradientColors
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onClose,
    onOpen,
    open: copied
  } = (0, _presentationHooks.useDisclose)();
  const handleCopyClick = (0, _react.useCallback)(async () => {
    await navigator.clipboard.writeText(link);
    onOpen();
    setTimeout(() => {
      onClose();
    }, 1500);
  }, [link, onClose, onOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.COPY_LINK_INPUT_WITH_BUTTON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      open: copied,
      placement: "top",
      title: copiedText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CopyLinkButton, {
        backgroundGradientColors: backgroundGradientColors,
        buttonContent: copied ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {}) : buttonText,
        fullWidth: fullWidth,
        onClick: handleCopyClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkContent, {
          children: link
        })
      })
    })
  });
};
exports.CopyLinkInputButton = CopyLinkInputButton;
//# sourceMappingURL=CopyLinkInputWithButton.js.map